import { withLazyFeatureGateErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy } from 'react';
export var ShareDialog = function () {
    var ShareDialogLazy = withLazyFeatureGateErrorBoundary(lazy(function () {
        return import(
        /*webpackChunkName: "share-dialog-component" */ '@office-start/share-dialog-component');
    }), 'ShareDialog', {
        disabledFeatureGateSelector: function (featureGates) { var _a; return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.shareFluentDialogGates) === null || _a === void 0 ? void 0 : _a.shareFluentDialogEnabled); },
        schedulePriority: IDLE_VERYLOW_PRIORITY,
    });
    return React.createElement(ShareDialogLazy, null);
};
//# sourceMappingURL=ShareDialog.js.map